export default "__VITE_ASSET__B7ch0FP4__"